import { Stack, styled } from '@mui/material';
import { BREAKPOINTS } from 'pvs-design-system';
import React from 'react';

type FormProps = {
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  children: React.ReactNode;
};

const FlexForm = styled('form')({
  display: 'flex',
});

const FieldContainer = styled(Stack)({
  flexDirection: 'column',
  marginTop: '4rem',
  marginLeft: 'auto',
  marginRight: 'auto',
  width: '89.8rem',
  minWidth: `${BREAKPOINTS.mobileSmall - 16}px`,
  padding: 0,
  gap: 0,
});

const Form: React.FC<FormProps> = ({ onSubmit, children }) => {
  return (
    <FlexForm onSubmit={onSubmit} noValidate>
      <FieldContainer>{children}</FieldContainer>
    </FlexForm>
  );
};

export default Form;
